import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const FilledCrown: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9837 4.25859L13.5672 10.5174C13.5391 10.6483 13.4663 10.7654 13.3612 10.8484C13.2561 10.9315 13.1253 10.9752 12.9914 10.9723H1.95938C1.82548 10.9752 1.69473 10.9315 1.58964 10.8484C1.48455 10.7654 1.41169 10.6483 1.38359 10.5174L0.0132215 4.25859C-0.00984089 4.15284 -0.00262681 4.04272 0.0340363 3.94088C0.0706994 3.83904 0.135327 3.7496 0.220505 3.68281C0.305917 3.61578 0.40854 3.57427 0.516532 3.56306C0.624523 3.55186 0.733483 3.57141 0.830838 3.61947L4.19343 5.24895L6.98024 0.320214C7.03046 0.231602 7.10328 0.157897 7.19129 0.106617C7.27929 0.0553382 7.37932 0.0283203 7.48117 0.0283203C7.58303 0.0283203 7.68306 0.0553382 7.77106 0.106617C7.85906 0.157897 7.93189 0.231602 7.98211 0.320214L10.7689 5.2547L14.1545 3.61371C14.2526 3.56174 14.3636 3.5392 14.4741 3.54882C14.5847 3.55845 14.6901 3.59981 14.7777 3.66794C14.8653 3.73608 14.9314 3.82807 14.9679 3.93286C15.0044 4.03765 15.0099 4.15076 14.9837 4.25859Z"
        fill="currentColor"
      />
    </svg>
  )
})

FilledCrown.displayName = 'FilledCrown'
